import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

interface TestimonialCardProps {
  name: string;
  company: string;
  text: string;
  location: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ name, company, text, location }) => {
  return (
    <motion.div
      className="bg-white p-6 rounded-lg shadow-md border-l-4 border-primary relative"
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
    >
      <div className="absolute -top-3 -left-3 text-primary bg-white rounded-full p-1">
        <Quote size={24} />
      </div>
      <p className="text-secondary italic mb-6 pt-4">{text}</p>
      <div className="flex items-center justify-between">
        <div>
          <p className="font-bold text-primary">{name}</p>
          <p className="text-sm text-gray-600">{company}</p>
        </div>
        <span className="text-sm text-gray-500">{location}</span>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;